const stepperData = [
  "施設選択",
  "対象施設一覧/施設情報・異動状況登録",
  "内容確認",
  "機構へ提出",
];

const infoManual = `　職員の異動状況について該当するものを選択してください。`;
const infoManualTwo = `　内容を確認後、画面下部にある「登録」ボタンを押してください。`;

export { stepperData, infoManual, infoManualTwo };
